import { render, staticRenderFns } from "./ModalDesentranhamentoAditivoApostilaView.vue?vue&type=template&id=278d7208"
import script from "./ModalDesentranhamentoAditivoApostilaView.vue?vue&type=script&lang=js"
export * from "./ModalDesentranhamentoAditivoApostilaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports